module.exports = __webpack_public_path__ + "04_glasses_blue.edab5c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/04_glasses_blue.png
// module id = /ioj
// module chunks = 0